import * as React from 'react';

import CircleBackButton24 from './CircleBackButton24';

export const circleBackButton24 = () => <CircleBackButton24 />;

export default {
    title: 'Icon/Fill/CircleBackButton24',
    component: CircleBackButton24,
    parameters: {
        notes: "`import CircleBackButton24 from 'box-ui-elements/es/icon/fill/CircleBackButton24';`",
    },
};
